import {TypeList} from "../Constants/DataModelToolConstants";

function ConvertFieldType(text, property) {

    let foundItem = TypeList.filter(
        function(item){ return item.text == text }
    )[0];

    if(foundItem)
    {
        switch(property)
        {
            case "value":
                return foundItem.value;
            case "shape":
                return foundItem.shape;
            case "variant":
                return foundItem.variant;
        }
    }
    else
    {
        return null;
    }
}

export default ConvertFieldType;